import { cn } from '@/lib/utils'
import type { OpenBookTrade } from './useOpenBook'

export function PremiumProtectionBadge({ value }: { value: OpenBookTrade['premiumProtection'] }) {
  if (!value) return null
  const paused = value.state === 'PAUSED' || value.state === 'OFF'
  const prices = `${value.stopLoss === null ? '' : `SL ₹${value.stopLoss.toFixed(2)}`} ${value.target === null ? '' : `TGT ₹${value.target.toFixed(2)}`}`.trim()
  return <span title={value.reason ?? `App-managed premium protection · ${prices} · ${value.state.toLowerCase()}`}
    className={cn('num shrink-0 rounded px-1.5 py-0.5 text-[8px] font-semibold', paused ? 'bg-warning/10 text-warning' : 'bg-primary/5 text-primary')}>
    {paused ? 'APP SL/TGT PAUSED' : value.state === 'WAITING' ? 'APP SL/TGT · WAITING FOR FILLS' : value.state === 'EXITING' ? 'APP SL/TGT · EXITING' : `APP ${prices}`}
  </span>
}
